import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { OficialMesa, OficialMesaJSON } from './OficialMesa';

const APROBAR_ACTION_KEY = 'aprobar';

export class OficialMesaSystem {
  private readonly base = '/oficialmesas';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getOficialMesaIdentifiedBy(id: string): Promise<OficialMesa> {
    const data = await this.requestHandler.get<OficialMesaJSON>(`${this.base}/${id}`);
    return OficialMesa.fromJSON(data);
  }

  async getList(): Promise<OficialMesa[]> {
    const data = await this.requestHandler.get<OficialMesaJSON[]>(`${this.base}`);
    return data.map((entity) => OficialMesa.fromJSON(entity));
  }

  async aprobar(id: string, observations: string) {
    const data = await this.requestHandler.put(`${this.base}/aprobar/${id}`, { observations: observations });
    return data;
  }

  public async executeMethodByKey(key: string, entityId: string, observations: string) {
    console.log('key > ', key);
    switch (key) {
      case APROBAR_ACTION_KEY:
        await this.aprobar(entityId, observations);
        return await this.getOficialMesaIdentifiedBy(entityId);
      default:
        console.error('Accion no encontrada');
    }
  }

  async getListForDropdown(): Promise<OficialMesa[]> {
    const data = await this.requestHandler.get<OficialMesaJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => OficialMesa.fromJSON(entity));
  }

  async save(entity: OficialMesa) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<OficialMesaJSON, OficialMesaJSON>(this.base, data);
    return OficialMesa.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
